import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {ColumnDef} from "@tanstack/react-table";
import {DataTable} from "@/lib/components/DataTable";
import {QuotesByCompanyDTO} from "@/api/data-contracts";
import {ReportI18N} from "@/translations";

interface QuotesByCompanyReportProps {
    data: QuotesByCompanyDTO[];
}

interface QuotesByCompanyRow extends QuotesByCompanyDTO {
    id: number;
}

/**
 * Report table showing quote counts per supplier company.
 */
const QuotesByCompanyReport: React.FC<QuotesByCompanyReportProps> = ({ data }) => {
    const { t } = useTranslation();

    const rows = useMemo<QuotesByCompanyRow[]>(
        () => data.map((item, index) => ({ ...item, id: index })),
        [data]
    );

    const columns = useMemo<ColumnDef<QuotesByCompanyRow>[]>(
        () => [
            {
                header: t(ReportI18N.page.column.company),
                accessorFn: (row) => row.companyName ?? "",
                id: "companyName"
            },
            {
                header: t(ReportI18N.page.column.count),
                accessorFn: (row) => row.quoteCount ?? 0,
                id: "quoteCount"
            }
        ],
        [t]
    );

    return <DataTable columns={columns} data={rows} noResultsValue="" striped maxHeight={940} />;
};

export default QuotesByCompanyReport;
